var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncreaseArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 8 10",
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.15221 4.50233 3.00235-3.00235m0 0 3.00235 3.00235m-3.00235-3.00235-.0003 8.00002",
    strokeWidth: 1.4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncreaseArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/increase-arrow.02efc1cf569e5f661f06ea2e8773daff.svg";